import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { MasterPageService } from 'src/app/core/services/master-page.service';

@Component({
  selector: 'app-questions-and-answers',
  templateUrl: './questions-and-answers.component.html',
  styleUrls: ['./questions-and-answers.component.scss']
})
export class QuestionsAndAnswersComponent implements OnInit {
  questionsAndAnswers;

  constructor(private masterPageService:MasterPageService,private appConfigService: AppConfigService) { }

  ngOnInit(): void {
    if(window['_loginType'] == window['_loginTypeIDPSelect']){
    this.appConfigService.getCommonQuestions().subscribe(    
      (data) => {
        this.questionsAndAnswers = data;
      },
      (error)=>{
        //TODO
      }
    );
  }
  }

}
